var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { domainService } from '~/config/server';
import { NetService } from '~/utils/net.service';
import { Inject, Debounce } from "~/core/decorator";
var RepairCasesService = /** @class */ (function () {
    function RepairCasesService() {
    }
    /**
     * 信修案件查询
     */
    RepairCasesService.prototype.repairCasesQuery = function (data, page) {
        var reqData = __assign(__assign({}, data), { overdueDaysMin: data.overdueDays.min, overdueDaysMax: data.overdueDays.max, labelName: data.labelName, caseMoneyMin: data.caseMoney ? data.caseMoney.min : '', caseMoneyMax: data.caseMoney ? data.caseMoney.max : '' });
        delete reqData.overdueDays;
        return this.netService.send({
            server: domainService.repairCasesController.repairCasesQuery,
            data: reqData,
            page: page
        });
    };
    /**
     *  添加案件修复信息
     */
    RepairCasesService.prototype.toRepair = function (data) {
        return this.netService.send({
            server: domainService.repairCasesController.toRepair,
            data: data,
            loading: true
        });
    };
    /**
     * 查询修复信息
     */
    RepairCasesService.prototype.queryRepairCaseInfo = function (caseId) {
        return this.netService.send({
            server: domainService.repairCasesController.queryRepairCaseInfo,
            data: { caseId: caseId }
        });
    };
    /**
     * 信修案件池-分案
     */
    RepairCasesService.prototype.confirmDistributeCase = function (data) {
        return this.netService.send({
            server: domainService.repairCasesController.distributeRepairCases,
            data: data,
            loading: true
        });
    };
    /**
     * 查看附件信息
     */
    RepairCasesService.prototype.viewUploadFile = function (fileIdsStr) {
        return this.netService.send({
            server: domainService.repairCasesController.viewUploadFile,
            data: {
                fileIds: fileIdsStr
            }
        });
    };
    RepairCasesService.prototype.getCollectionTypeByCaseId = function (caseId) {
        return this.netService.send({
            server: domainService.repairCasesController.getCollectionTypeByCaseId,
            data: {
                caseId: caseId
            }
        });
    };
    /**
     * 信修案件批量下载
     */
    RepairCasesService.prototype.downRepairCaseInfos = function (data) {
        var reqData = __assign(__assign({}, data), { overdueDaysMin: data.overdueDays.min, overdueDaysMax: data.overdueDays.max });
        delete reqData.overdueDays;
        return this.netService.send({
            server: domainService.repairCasesController.downRepairCaseInfos,
            data: reqData
        });
    };
    __decorate([
        Inject(NetService)
    ], RepairCasesService.prototype, "netService", void 0);
    __decorate([
        Debounce()
    ], RepairCasesService.prototype, "toRepair", null);
    return RepairCasesService;
}());
export { RepairCasesService };
